import {AfterViewInit, Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {ITela} from "../../objeto/ITela";
import {ConstantsService} from "../../services/ConstantsService";
import {ProdutoService} from "../../services/produto.service";
import {ActivatedRoute, Router} from "@angular/router";
import {DominiosService} from "../../services/dominios.service";
import {DeviceDetectorService} from "ngx-device-detector";
import {SiteProdutoComponent} from "../../site-produto/site-produto.component";
import {Location} from "@angular/common";
import {DialogService} from "@progress/kendo-angular-dialog";
import {SiteMontarpizzaComponent} from "../../site-montarpizza/site-montarpizza.component";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import { fromEvent } from 'rxjs';

declare var _;

@Component({
  selector: 'app-tela-busca-produtos',
  templateUrl: './tela-busca-produtos.component.html',
  styleUrls: ['./tela-busca-produtos.component.scss']
})
export class TelaBuscaProdutosComponent implements OnInit, ITela, AfterViewInit  {
  @ViewChild('menutopo') menutopo: any;
  @ViewChild(CdkVirtualScrollViewport)
  viewport: CdkVirtualScrollViewport;
  carregando = false;
  produtos = [];
  listaItensPorCategoria: any = {};
  categorias: any  = [];
  produtosPorCategoria: any = {}
  nomePagina: string;
  veioParamsNoState = false;
  isMobile = false;
  window: any;
  ehMesa: boolean;
  nomeCategoria: string;
  layoutHorizontal: boolean;
  carregandoPagina: boolean;
  qtdPorLinha: number;
  valorBuscado: any;
  destaques =  [];
  nomeCategoriaDestaque = 'DESTAQUES';
  categoriaDestaque = {
    id: 2,
    nome: this.nomeCategoriaDestaque
  };

  categoriaMonteSuaPizza = {
    id: 1,   nome: ''
  };
  timerbusca: any;
  termoBusca
  msgBusca
  ehMercado: boolean
  empresa: any = {};

  constructor(private router: Router, private constantsService: ConstantsService,
              private produtoService: ProdutoService, private dominiosService: DominiosService,
              private detectorDevice: DeviceDetectorService, private dialogService: DialogService,
              private activatedRoute: ActivatedRoute, private location: Location) {
    this.nomePagina = dominiosService.obtenhaRaizCardapio();

    this.isMobile = this.detectorDevice.isMobile();

    if( window.history.state.produtos ) {
      this.veioParamsNoState = true;
    }
    this.constantsService.empresa$.subscribe( (empresa) => {
      if(empresa)
        this.layoutHorizontal = empresa.tipoDeLoja === 'MERCADO' || empresa.tipoDeLoja === 'ECOMMERCE';
    });

    window.scroll(0, 0);
    this.carregando = true;
  }

  ngOnInit() {
    if( window.history.state.produtos ) {
      this.veioParamsNoState = true;

    }
    console.log("**chamou ng on init**")
    this.activatedRoute.queryParams.subscribe( (params) => {
      this.nomeCategoria = params.c
      this.constantsService.empresa$.subscribe( (empresa) => {
        if(!empresa || this.produtos.length )  return;
        this.empresa = empresa;
        this.ehMercado = empresa.tipoDeLoja === 'MERCADO';
        this.layoutHorizontal =  this.ehMercado || empresa.tipoDeLoja === 'ECOMMERCE';
        if( empresa.nomeCategoriaDestaques ) {
          let nomeAnterior = this.categoriaDestaque.nome
          this.categoriaDestaque.nome  = empresa.nomeCategoriaDestaques;
          this.produtosPorCategoria[this.categoriaDestaque.nome] = this.produtosPorCategoria[nomeAnterior]
        }

        console.log('*largura da janela*', document.getElementsByClassName('mercado')[0].clientWidth)
        this.qtdPorLinha = Math.floor(
          (document.getElementsByClassName('mercado')[0].clientWidth) / 165)

        if(!this.ehMercado && window.history.state.produtosPorCategoria && window.history.state.produtos)
        {
          this.produtos = window.history.state.produtos;
          this.categorias = window.history.state.categorias;
          this.produtosPorCategoria = window.history.state.produtosPorCategoria;
          this.ehMesa = window.history.state.ehMesa;
          this.agrupeCategorias();
          this.carregando = false
          console.log('** carregou pelo state **')
          return
        }

        let timer
        const obs = fromEvent(window, 'resize').subscribe(
          () => {
            if(timer) clearTimeout(timer)
            timer = setTimeout(() =>
            {
              console.log('*largura da janela*', document.getElementsByClassName('mercado')[0].clientWidth)
              this.qtdPorLinha = Math.floor((document.getElementsByClassName('mercado')[0].clientWidth) / 165)

              this.listaItensPorCategoria = {}
              for(let categoria of this.categorias)
                this.listaItensPorCategoria[categoria.nome] = this.agrupeDeXemX(this.produtosPorCategoria[categoria.nome],
                  this.qtdPorLinha)
              console.log('*** REDIMENSIONANDO ***')
            }, 250)

          })

        let quantidadePorPagina = this.layoutHorizontal ? 50 : null
        let indice = this.layoutHorizontal ? 0 : null

        this.produtoService.listeAhVenda(this.empresa, this.ehMesa ? 'MESA' : 'DELIVERY', this.layoutHorizontal, this.nomeCategoria,
          quantidadePorPagina, indice, this.termoBusca).subscribe((resposta: any) => {
          this.processeProdutos(resposta);
        });
      });
    });
  }

  processeProdutos(resposta: any) {
    this.produtos = this.produtos.concat(resposta.produtos);
    this.categorias = resposta.categorias;

    this.produtosPorCategoria =
      _.groupBy(resposta.produtos, produto => produto.categoria ? produto.categoria.nome.trim() : 'Outros');

    this.agrupeCategorias();

    this.carregando = false;
  }

  private agrupeCategorias(){
    this.definaCategoriasFixas();
    this.listaItensPorCategoria = {}
    if(this.nomeCategoria) {
      console.log('** definiu o nome da categoria **')
      this.listaItensPorCategoria[this.nomeCategoria] =
        this.agrupeDeXemX(this.produtosPorCategoria[this.nomeCategoria], this.qtdPorLinha)
    }
    else
      for(let categoria of this.categorias)
        this.listaItensPorCategoria[categoria.nome] =
          this.agrupeDeXemX(this.produtosPorCategoria[categoria.nome], this.qtdPorLinha)
  }

  getPosicao(nomeCategoria){
    let _produto = this.produtos.find( produto => produto.categoria && produto.categoria.nome === nomeCategoria)

    let posicao = _produto ? _produto.categoria.posicao : this.produtos.length;

    return posicao;
  }

  deveExibirTopo() {
    return false;
  }
  deveExibirMenu(){
    return true;
  }

  abraDetalhesProduto(produto: any) {
    if(!produto.montar){
      this.window = SiteProdutoComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
        this.dialogService, this.isMobile, produto);
    } else {
      this.window =  SiteMontarpizzaComponent.abraComoPopup(this.router, this.location, this.activatedRoute,
        this.dialogService, this.isMobile, produto);
    }

  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    if( this.window ) {
      this.window.close({
        back: true
      });
    }
  }

  exibirUnidade(produto: any) {
      return produto.tipoDeVenda && produto.tipoDeVenda === 'Peso';
  }

  private exibaApenasProdutosDaCategoria(categoria: any, indiceInicial = 0) {
    if( !categoria ) {
      return;
    }

    if(this.produtosPorCategoria[categoria.nome] && this.produtosPorCategoria[categoria.nome].length > indiceInicial) {
      this.produtos = this.produtosPorCategoria[categoria.nome]
    }

    const mapProdutosPorCategoria = {};

    mapProdutosPorCategoria[categoria.nome] = this.produtos;

    this.produtosPorCategoria = mapProdutosPorCategoria;

    this.categorias = [categoria];
  }

  ngAfterViewInit(): void {
    this.activatedRoute.queryParams.subscribe( (params) => {
      this.menutopo.query = params.q;
    });

    if(this.layoutHorizontal &&  this.viewport)
      this.viewport.elementScrolled().subscribe((event) => {
        this.busqueMaisProdutos(event)
      })
  }

  apertouVoltar($event) {
    this.location.back();
  }

  busqueComFiltro(filtro: string) {
    this.carregando = true
    this.produtoService.listeAhVenda(this.empresa, this.ehMesa ? 'MESA' : 'DELIVERY', this.layoutHorizontal, this.nomeCategoria,
      50, 0, filtro ).subscribe((resposta: any) => {
      this.produtos = resposta.produtos;
      this.categorias = resposta.categorias;

      this.produtosPorCategoria =  _.groupBy(this.produtos, produto => produto.categoria ? produto.categoria.nome : 'Outros')

      this.definaCategoriasFixas();

      console.log('** categorias **', this.categorias)
      this.listaItensPorCategoria = {}
      if(this.nomeCategoria) {

        this.listaItensPorCategoria[this.nomeCategoria] =
          this.agrupeDeXemX(this.produtosPorCategoria[this.nomeCategoria], this.qtdPorLinha)
      }
      else
        for(let categoria of this.categorias)
          this.listaItensPorCategoria[categoria.nome] =
            this.agrupeDeXemX(this.produtosPorCategoria[categoria.nome], this.qtdPorLinha)


      console.log('** LISTA ITENS POR CATEGORIA **', this.listaItensPorCategoria)
      this.carregando = false;
    })
  }

  busqueMaisProdutos($event) {
    if(!this.qtdPorLinha) return;
    if(!this.layoutHorizontal) return;
    if(this.valorBuscado) return;
    const end = this.viewport.getRenderedRange().end;
    const total = this.viewport.getDataLength();
    console.log(`${end}, '>=', ${total}`);
    console.log('Quantidade de produtos:', this.produtos.length)
    if (end === total) {

      console.log('agora deveria procurar próxima página: ' + this.qtdPorLinha)

      if(this.carregandoPagina) {
        console.log('não vai buscar porque já está buscando')
        return;
      }
      this.carregandoPagina = true;
      console.log('Categoria sendo buscada: ' + this.nomeCategoria)
      this.produtoService.listeAhVenda(this.empresa, this.ehMesa ? 'MESA' : 'DELIVERY', this.layoutHorizontal, this.nomeCategoria,
        50, this.produtos.length ).subscribe((resposta: any) => {
          let produtos = []
          if(resposta)
            produtos = resposta.produtos
        if(produtos.length === 0) {
          console.log("não tem mais produtos a adicionar")
          this.carregandoPagina = false;
          return;
        }


        if(this.produtos[this.produtos.length - 1].id === produtos[produtos.length - 1].id) {
          this.carregandoPagina = false;
          return;
        }


        this.produtos = this.produtos.concat(produtos);

        this.produtosPorCategoria =  _.groupBy(this.produtos, produto => produto.categoria ? produto.categoria.nome : 'Outros')

        this.listaItensPorCategoria[this.nomeCategoria] = this.agrupeDeXemX(this.produtosPorCategoria[this.nomeCategoria], this.qtdPorLinha)


        for(let produto of produtos) {

          if(produto.camposAdicionais && produto.camposAdicionais.length > 0) {
            let valorMinimo = produto.preco

            for(let campoAdicional of produto.camposAdicionais)
              if(campoAdicional.obrigatorio) {
                let maisBarato = campoAdicional.opcoesDisponiveis[0]
                for(let opcao of campoAdicional.opcoesDisponiveis)
                  if(opcao.valor < maisBarato.valor) maisBarato = opcao

                valorMinimo += maisBarato.valor

              }

            if(valorMinimo > produto.preco) produto.valorMinimo = valorMinimo
            //teste
          }
        }

        const mapCategoriasPorId = {};
        const mapCategoriasPorNome = {};

        this.produtos.map(produto => {
          if( produto.categoria ) {
            mapCategoriasPorId[produto.categoria.id] = produto.categoria;
            mapCategoriasPorNome[produto.categoria.nome] = produto.categoria;
          }
        });

      //  this.categorias = Object.values(mapCategoriasPorId).sort( (a: any, b: any) => a.posicao - b.posicao);


        this.carregandoPagina = false;
      })
    }
  }

  private agrupeDeXemX(produtos: any[], x = 6, indiceInicial = 0, listaAtual = []) {
    let listaAgrupada: any[] = [...listaAtual];
    let inicio = indiceInicial;

    if(!produtos) return;

    if(listaAgrupada.length > 0 && listaAgrupada[listaAgrupada.length - 1].length < x)
      inicio = this.insiraProdutosNoItem(inicio, produtos, x, listaAgrupada[listaAgrupada.length - 1])


    for(let i = inicio; i < produtos.length; i = i + x) {
      let item: any = []
      let y = this.insiraProdutosNoItem(i, produtos, x, item);
      listaAgrupada.push(item)
    }

    return listaAgrupada
  }

  private insiraProdutosNoItem(i: number, produtos: any[], x: number, item: any) {
    let y;
    let quantidadeAdicionar = x - item.length
    let quantidadeInserido
    for (y = i, quantidadeInserido = i; (y < produtos.length) && (quantidadeInserido < (i + quantidadeAdicionar)); y++)
      if(produtos[y].preco > 0 || produtos[y].valorMinimo > 0) {
        item.push(produtos[y])
        quantidadeInserido++;
      }


    return y
  }

  testeBusca(valor: any) {
    if(this.carregando) return;

    delete  this.msgBusca;
    this.termoBusca = valor;

    if(this.timerbusca) clearTimeout(this.timerbusca)
    if(valor.length  >= 3){
      this.timerbusca = setTimeout( () => {
        this.valorBuscado = valor;
        this.busqueComFiltro(valor)
      }, 900)
    } else {
      this.msgBusca = 'informe pelo menos 3 letras'
    }

  }

  private definaCategoriasFixas() {
    let pizzasMontar = this.produtos.filter( produto => produto.template != null && produto.template.montarPizza);

    if(pizzasMontar.length > 0){
      this.categoriaMonteSuaPizza.nome = pizzasMontar[0].template.nomeCategoriaMontar;
      this.categorias.splice(0, 0,  this.categoriaMonteSuaPizza);
      this.produtosPorCategoria[this.categoriaMonteSuaPizza.nome] = []

      pizzasMontar.forEach( (produtoPizza: any) => {
        produtoPizza.tamanhos.forEach( (tamanhoPizza: any) => {

          if(tamanhoPizza.qtdeSabores >= 1){

            let nome = String(`${produtoPizza.template.nome} ${tamanhoPizza.descricao} `),
              descricao = String(`Monte ${nome}`),
              preco = tamanhoPizza.novoPreco ? tamanhoPizza.novoPreco : tamanhoPizza.preco;

            if(tamanhoPizza.qtdeSabores > 1){
              nome = String(`${nome} com até  ${tamanhoPizza.qtdeSabores} sabores`)
              descricao = String(`${descricao} com até  ${tamanhoPizza.qtdeSabores} sabores`)
            }

            let produtoCategoria =
              this.produtosPorCategoria[this.categoriaMonteSuaPizza.nome].find(
                produtoCategogia => produtoCategogia.id === tamanhoPizza.template.id);

            if(!produtoCategoria){
              produtoCategoria =  {
                id: tamanhoPizza.template.id, nome: nome, descricao: descricao, montar: true,
                template: produtoPizza.template, tamanho: tamanhoPizza, valorMinimo: preco,
                sabores: [], camposAdicionais: produtoPizza.camposAdicionais, tamanhos: [],
              }
              this.produtosPorCategoria[this.categoriaMonteSuaPizza.nome].push( produtoCategoria);
            }

            produtoCategoria.sabores.push(produtoPizza);

            if(produtoCategoria.preco < preco)
              produtoCategoria.valorMinimo = preco
          }


        })
      })

    }

    this.destaques = [];

    this.produtos.forEach( (produto: any) => {
      if(produto.destaque) this.destaques.push(Object.assign({}, produto))

      if(produto.tamanhos && produto.tamanhos.length){
        if(produto.tamanhos.find( tamanho => tamanho.destaque) != null)
          this.destaques.push(Object.assign({}, produto))
      }
    })

    this.destaques.forEach( produto => produto.destacado = true);

    if( this.destaques.length) {
      this.categorias.splice(0, 0,  this.categoriaDestaque);
      this.produtosPorCategoria[this.categoriaDestaque.nome] =  this.destaques;
    }
  }

  deveTerBordas() {
    return true;
  }

  deveExibirBannerTema() {
    return false;
  }
}
